import { inject, Injectable } from '@angular/core';
import { FeesMasterDetailsDTO, FeeStructureMasterClonerByClassIdRequestDTO, FeeStructureMasterCreateRequestDTO, FeeStructureMasterDeleteRequestDTO, FeeStructureMasterDTO, FeeStructureMasterList, FeeStructureMasterReadByClassIdRequestDTO, FeeStructureMasterReadByIdRequestDTO, FeeStructureMasterUpdateRequestDTO, StudentFeeStructureMappingAutoAssignFeesRequestDTO, StudentFeeStructureMappingAutoAssignFeesResponseDTO } from './fee-structure-master.interface';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeeStructureMaster_Create, FeeStructureMaster_Update, FeeStructureMaster_ReadAll, FeeStructureMaster_Delete, FeeStructureMaster_ReadById, FeeStructureMaster_ReadByClassId, FeeStructureMaster_ReadFeesDetailsByClassId, FeeStructureMaster_ClonerByClassId, StudentFeeStructureMapping_AutoAssignFees } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class FeeStructureMasterService {

  constructor() { }
  http = inject(HttpClient)
  FeeStructureMaster_Create(data: FeeStructureMasterCreateRequestDTO): Observable<FeeStructureMasterDTO> {
    return this.http.post<FeeStructureMasterDTO>(FeeStructureMaster_Create, data)
  }

  FeeStructureMaster_Update(data: FeeStructureMasterUpdateRequestDTO): Observable<FeeStructureMasterDTO> {
    return this.http.post<FeeStructureMasterDTO>(FeeStructureMaster_Update, data)
  }

  FeeStructureMaster_ReadAll(): Observable<FeeStructureMasterList> {
    return this.http.get<FeeStructureMasterList>(FeeStructureMaster_ReadAll)
  }
  FeeStructureMaster_Delete(data: FeeStructureMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(FeeStructureMaster_Delete, data)
  }


  FeeStructureMaster_ReadById(data: FeeStructureMasterReadByIdRequestDTO): Observable<FeeStructureMasterDTO> {
    return this.http.post<FeeStructureMasterDTO>(FeeStructureMaster_ReadById, data)
  }

  FeeStructureMaster_ReadByClassId(data: FeeStructureMasterReadByClassIdRequestDTO): Observable<FeeStructureMasterList> {
    return this.http.post<FeeStructureMasterList>(FeeStructureMaster_ReadByClassId, data)
  }
  FeeStructureMaster_ReadFeesDetailsByClassId(data: FeeStructureMasterReadByClassIdRequestDTO): Observable<FeesMasterDetailsDTO> {
    return this.http.post<FeesMasterDetailsDTO>(FeeStructureMaster_ReadFeesDetailsByClassId, data)
  }

  FeeStructureMaster_ClonerByClassId(data:FeeStructureMasterClonerByClassIdRequestDTO):Observable<void> {
    return this.http.post<void>(FeeStructureMaster_ClonerByClassId, data)
  }
  
  StudentFeeStructureMapping_AutoAssignFees(
    data: StudentFeeStructureMappingAutoAssignFeesRequestDTO
  ): Observable<StudentFeeStructureMappingAutoAssignFeesResponseDTO> {
    return this.http.post<StudentFeeStructureMappingAutoAssignFeesResponseDTO>(
      StudentFeeStructureMapping_AutoAssignFees,
      data
    );
  }

}
